import React, {Fragment} from 'react';
import classes from './DeleteEligibilityConfirmation.css';
import Label from '../../UI/Label2/Label2';
import Button from '../../UI/Button/Button';
import { getPortalNameForEligibilityScreen } from '../../shared/utility';

const deleteEligibilityConfirmation = (props) => {

    let form = null;

    const memberPortalInfo = (
        <div>
            <strong className={classes.Caution}>You're about to delete {getPortalNameForEligibilityScreen(props.mbrPortalInfo.portalShortNm, props.portals)} eligibility record for this member:</strong>
            <br/><br/>
            <Label labelText="Portal Name: " labelValue={getPortalNameForEligibilityScreen(props.mbrPortalInfo.portalShortNm, props.portals)} displayType="horizontal"/>
            <Label labelText="First Name: " labelValue={props.mbrPortalInfo.portalFirstNm} displayType="horizontal"/>
            <Label labelText="Last Name: " labelValue={props.mbrPortalInfo.portalLastNm} displayType="horizontal"/>
            <Label labelText="Date of Birth: " labelValue={props.mbrPortalInfo.portalDob} displayType="horizontal"/>
            <Label labelText={props.mbrPortalInfo.portalShortNm==='CAP'?"FARO ID: ":"Subscriber ID: "} labelValue={props.mbrPortalInfo.portalSubscriberId} displayType="horizontal"/>
            <Label labelText="Member ID: " labelValue={props.mbrPortalInfo.portalSpecificMemberId} displayType="horizontal"/>
            <Label labelText="Policy Number: " labelValue={props.mbrPortalInfo.portalPolicyNbr} displayType="horizontal"/>
            <Label labelText="Gender: " labelValue={props.mbrPortalInfo.portalGender ? props.mbrPortalInfo.portalGender : '-'} displayType="horizontal"/>
            <Label labelText="State: " labelValue={props.mbrPortalInfo.portalState ? props.mbrPortalInfo.portalState : '-'} displayType="horizontal"/>
            <Label labelText="Zip Code: " labelValue={props.mbrPortalInfo.portalZip ? props.mbrPortalInfo.portalZip : '-'} displayType="horizontal"/>
        </div>
    );

        const buttons = (
            <div className={classes.ButtonDiv}>
                <Button id="cancel" btnType="Cancel" clicked={props.modalClosed}>Cancel</Button>
                <Button id="delete" btnType="AddAccountSearch" clicked={() => props.deleteEligibility(props.mbrPortalInfo)}>Delete</Button>
            </div>
        );

        form = 
            <Fragment>
                {memberPortalInfo}
                <br/>
                <br/>
                {buttons}
            </Fragment>

    return form;
}

export default deleteEligibilityConfirmation;